import { render, staticRenderFns } from "./AddPay.vue?vue&type=template&id=c23768c0&scoped=true"
import script from "./AddPay.vue?vue&type=script&lang=js"
export * from "./AddPay.vue?vue&type=script&lang=js"
import style0 from "./AddPay.vue?vue&type=style&index=0&id=c23768c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23768c0",
  null
  
)

export default component.exports